import React from "react";
import Select from "@amzn/awsui-components-react/polaris/select";
import {
  MONTHS_FILTER,
  YEARS_FILTER,
} from "features/calculate-taxes-table-filters/constants";
import PropertyFilter, {
  PropertyFilterProps,
} from "@amzn/awsui-components-react/polaris/property-filter";
import Grid from "@amzn/awsui-components-react/polaris/grid";
import { useManualUploadsYearMonthFilters } from "./hooks";
import { useNotifications } from "features/notifications/hooks";
import { IManualUploadsTableFiltersProps } from "./interfaces";
import { getFilterCounterText } from "components/client-side-paginated-table/utils";
import { PROPERTY_FILTERING_I18N_CONSTANTS } from "components/table-state/constants";

const ManualUploadsYearMonthFilters: React.FC<
  IManualUploadsTableFiltersProps
> = ({ filteringProperties, propertyFilterProps, filteredItemsCount }) => {
  const {
    manualUploadsYearMonthFilters: { year, month },
    updateYear,
    updateMonth,
  } = useManualUploadsYearMonthFilters();

  const { clearNotifications } = useNotifications();
  const PROPERTY_FILTER_PROPS: PropertyFilterProps = filteringProperties && {
    ...propertyFilterProps,
    i18nStrings: PROPERTY_FILTERING_I18N_CONSTANTS,
    countText: getFilterCounterText(filteredItemsCount),
  };
  return (
    <div data-testid="manual-uploads-year-month-filters">
      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 2 }, { colspan: 2 }]}>
        <div>
          {PROPERTY_FILTER_PROPS && (
            <PropertyFilter {...PROPERTY_FILTER_PROPS} />
          )}
        </div>
        <div>
          <Select
            data-testid="manual-uploads-year-filter"
            selectedOption={{ label: year.toString(), value: year.toString() }}
            options={YEARS_FILTER}
            placeholder="Year"
            filteringType="auto"
            onChange={({ detail }) => {
              clearNotifications();
              updateYear(parseInt(detail.selectedOption.value!));
            }}
          />
        </div>
        <div>
          <Select
            data-testid="manual-uploads-month-filter"
            selectedOption={{
              label: month,
              value: month,
            }}
            options={MONTHS_FILTER}
            placeholder="Month"
            filteringType="auto"
            onChange={({ detail }) => {
              clearNotifications();
              updateMonth(detail.selectedOption.value!);
            }}
          />
        </div>
      </Grid>
    </div>
  );
};

export default ManualUploadsYearMonthFilters;
